// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2p00A","title":"Header_title__3v_pM","left":"Header_left__2WxFa","clinicName":"Header_clinicName__7RGno"};